<script>
    // Import animated counter component
    import Vue3Autocounter from 'vue3-autocounter';

    // Import general mixin for shared functionality.
    import mixin from '../../mixin';

    export default {
        components: {
            Vue3Autocounter
        },
        mixins: [mixin],
        props: {
            data: Object,
        },
        data() {
            return {
                activeFilter: '',
                name: 'detailedClosingReason',
                facetAlias: 'afsluit_oms',
                searchTerm: '',
            };
        },
        computed: {
            facetsSet() {
                return this.data && this.data.facets && this.data.facets.length;
            },
            filters() {
                if (!this.facetsSet) return [];
                const facet = this.data.facets.find(f => f.alias === this.facetAlias);
                if (!facet || !facet.options || !facet.options.length) return [];

                let filters = facet.options.filter(o => o.filteredAmount).map(option => ({
                    label: option.valueAlias,
                    count: option.filteredAmount
                }));

                if (this.searchTerm) {
                    filters = filters.filter(filter => filter.label.toLowerCase().includes(this.strip(this.searchTerm.toLowerCase())));
                }
                if (!filters.length) return [];

                return filters.sort((a, b) => b.count - a.count);
            },
        },
        methods: {
            onFilterSelect(filter) {
                if (!filter) return;
                const filterChosen = filter.label === this.activeFilter;
                this.activeFilter = filterChosen ? '' : filter.label;

                this.$emit('filter', {
                    type: this.name,
                    value: this.activeFilter
                });
            }
        },
    };
</script>

<template>
    <div v-if="facetsSet" class="dashboard-widget dashboard-widget--filter">
        <form>
            <div class="field">
                <div class="control">
                    <label for="searchStatus">{{ $store.getters.getText('dashboardFilterDetailedclosingreason') }}</label>
                    <input type="search"
                           id="searchStatus"
                           class="input"
                           :placeholder="$store.getters.getText('dashboardLabelSearch')"
                           v-model="searchTerm" />
                </div>
            </div>
            <div v-for="(filter, index) in filters" :key="filter.label" class="field">
                <div class="control">
                    <input type="radio"
                           name="detailedClosingReason"
                           :id="`detailedClosingReason${index}`"
                           class="by-radio"
                           @click="onFilterSelect(filter)"
                           :value="filter.label"
                           v-model="activeFilter" />
                    <label :for="`detailedClosingReason${index}`" class="by-checkable">
                        <small>{{ filter.label }}</small>
                        <small class="ml-2">(<vue3-autocounter :endAmount="filter.count" separator="." duration="0.5" />)</small>
                    </label>
                </div>
            </div>
        </form>
    </div>
</template>
